export enum STATES {
  TERMS_AND_CONDITIONS = "terms and conditions",
  INIT = "init",
  STARTED = "started",
  RECORD = "record",
  RECORDED = "recorded",
  SAVED = "saved",
  FAILED = "failed",
  ALL = "*",
}
